
import { AutoSaleRowSetting } from "@/models/auto-sale-row-setting";
import Vue from "vue";
import { FrontendFunc } from "@/models/frontend-func";
import AppDossierAutoSaleRowSettingEditFunc from "./DossierAutoSaleRowSettingEditFunc.vue";
import AppDossierAutoSaleRowSettingAddSharedFunc from "./DossierAutoSaleRowSettingAddSharedFunc.vue";

export default Vue.extend({
	data(){
		return {
			toEditFunc: null as null | FrontendFunc,
			addSharedFuncModalOpen: false
		};
	},
	props: {
		setting: {
			type: Object as ()=>AutoSaleRowSetting,
			required: true
		}
	},
	computed: {
		descriptionValid():boolean {
			if (this.setting.Description.trim() == "") {
				return false;
			}
			return true;
		},
		valid():boolean {
			if (!this.descriptionValid) return false;
			for (let func of this.setting.Funcs){
				if (!this.isFuncNameValid(func.Name)){
					return false;
				}
			}
			for (let func of this.setting.SharedFuncList){
				if (!this.isFuncNameValid(func.Alias)){
					return false;
				}
			}
			return true;
		}
	},
	watch: {
		valid: {
			immediate: true,
			handler(){
				this.$emit("valid", this.valid);
			}
		}
	},
	methods: {
		addFunction(){
			let fun = new FrontendFunc();
			this.setting.Funcs.push(fun);
		},
		editFunc(func:FrontendFunc){
			this.toEditFunc = func;
		},
		async deleteFunc(i:number){
			let func = this.setting.Funcs[i];
			let confirm = await this.$wf.confirm(`Weet je zeker dat je de functie ${func.Name} wilt verwijderen?`, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			this.setting.Funcs.splice(i,1);
		},
		isFuncNameValid(funcName:string):boolean {
			if (!FrontendFunc.validNameRegex.test(funcName)) return false;
			let occurance = 0;
			for (let f of this.setting.Funcs){
				if (f.Name == funcName) {
					occurance++;
				}
			}
			for (let f of this.setting.SharedFuncList){
				if (f.Alias == funcName){
					occurance++;
				}
			}
			if (occurance>1){
				return false;
			}
			return true;
		},
		addSharedFunction(){
			this.addSharedFuncModalOpen = true;
		},
		deleteSharedFunc(i:number){
			this.setting.SharedFuncList.splice(i,1);
		}
	},
	components: {
		AppDossierAutoSaleRowSettingEditFunc,
		AppDossierAutoSaleRowSettingAddSharedFunc
	}
});
